// Redesign phase 3: one Activity timeline from the editor's three history dialogs (docs/ui_redesign/03-invoice-editor-common.md).
//   changes    GET /api/invoicedocument/invoicechangelog/{id}                      (ChangeLogLookup)
//   approvals  GET /api/invoicedocument/invoicedocumentroutinghistory/{id}/         (InvoiceDocumentRoutingHistory)
//   routing    GET /api/invoicedocument/invoicedocumentapprovalroutinghistory/{id}  (InvoiceDocumentApprovalRoutingHistory)
//   discrepant GET /api/invoicedocument/invoicedocumentdiscrepantroutinghistory/{id}

export const KINDS = [
	['all', 'All'],
	['change', 'Changes'],
	['approval', 'Approvals'],
	['routing', 'Routing']
];

const time = v => {
	const t = v ? new Date(v).getTime() : NaN;
	return Number.isNaN(t) ? null : t;
};
const text = v => (v == null ? '' : String(v).trim());

export function toTimeline({ changes = [], approvals = [], routing = [], discrepant = [] }) {
	const items = [];
	changes.forEach((c, i) => {
		const field = text(c.fieldName);
		const from = text(c.oldValue), to = text(c.newValue);
		items.push({
			key: 'c' + i, kind: 'change', at: time(c.changedDate), raw: c.changedDate, who: text(c.changedBy),
			title: [text(c.action), field].filter(Boolean).join(' · ') || 'Changed',
			detail: from || to ? `${from || '(blank)'} → ${to || '(blank)'}` : ''
		});
	});
	approvals.forEach((a, i) => items.push({
		key: 'a' + i, kind: 'approval', at: time(a.timestamp), raw: a.timestamp, who: text(a.resourceName),
		title: [text(a.status), text(a.approvalLevel)].filter(Boolean).join(' · ') || 'Approval', detail: text(a.approvalRejectionComment)
	}));
	routing.forEach((r, i) => items.push({
		key: 'r' + i, kind: 'routing', at: time(r.createdDate), raw: r.createdDate, who: text(r.routedBy),
		title: `Routed to ${text(r.routedTo) || '—'}`, detail: text(r.comments)
	}));
	discrepant.forEach((r, i) => items.push({
		key: 'd' + i, kind: 'routing', at: time(r.createdDate), raw: r.createdDate, who: text(r.routedBy),
		title: `Routed to ${text(r.routedTo) || '—'} for correction`, detail: text(r.comments)
	}));
	// Newest first; entries without a readable date go last, in the order the server sent them.
	return items
		.map((it, i) => ({ ...it, i }))
		.sort((x, y) => (y.at ?? -Infinity) - (x.at ?? -Infinity) || x.i - y.i)
		.map(({ i, ...it }) => it);
}

export const countByKind = items => items.reduce((acc, it) => ({ ...acc, [it.kind]: (acc[it.kind] || 0) + 1, all: acc.all + 1 }), { all: 0 });
